module.exports = __webpack_public_path__ + "img/loader.de32d446.svg";